import { getField, updateField } from 'vuex-map-fields';


const SET_SHOW = 'SET_SHOW';

const state = () => ({
    message: {
        text: 'El pago de su pedido se ha realizado con éxito. Muchas gracias por su compra.',
        center: true
    },
    title: {
        text: 'Pago realizado con éxito',
        show: true,
    },
    confirm_button: {
        text: 'Entendido',
        show: true
    },
    cancel_button: {
        show: false
    },
    question: {
        show: false
    },
    icon: 'mdi-receipt-text-check-outline',
    show: false,
    persistent: true
})

const mutations = {
    [SET_SHOW]: (state, show) => {
        state.show = show;
    },
    updateField,
}

const getters = {
    show: state => state.show,
    text: state => state.message.text,
    text_center: state => state.message.center,
    text_title: state => state.title.text,
    show_title: state => state.title.show,
    text_confirm_button: state => state.confirm_button.text,
    show_confirm_button: state => state.confirm_button.show,
    show_cancel_button: state => state.cancel_button.show,
    show_question: state => state.question.show,
    icon: state => state.icon,
    persistent: state => state.persistent,
    getField
}

const openModal = ({ commit }) => {
    commit(SET_SHOW, true);
}

const closeModal = ({ commit }) => {
    commit(SET_SHOW, false);
}

const actions = {
    openModal,
    closeModal
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}